import { NgModule } from '@angular/core';
import { PieChartComponent } from './pie-chart.component';
import {SharedModule} from '../../_shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [PieChartComponent],
  exports: [PieChartComponent]
})
export class PieChartModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/pie-chart/pie-chart.module.ts